import { render, staticRenderFns } from "./ProductVariantFeedbackModal.vue?vue&type=template&id=13fdfcdd&"
import script from "./ProductVariantFeedbackModal.vue?vue&type=script&lang=js&"
export * from "./ProductVariantFeedbackModal.vue?vue&type=script&lang=js&"
import style0 from "./ProductVariantFeedbackModal.vue?vue&type=style&index=0&id=13fdfcdd&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports